export default __webpack_public_path__ + "static/media/main_slide_Image1.e17501d2.jpg";